import { useEffect } from 'react'

import { handleLogin } from '@/utils/auth'

export default function UnauthenticatedView() {
  useEffect(() => {
    handleLogin()
  }, [])

  return <></>
}
